// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PayInProviderIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "PayInProvider/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 15.942c0 1.075.825 1.941 1.85 1.941h2.092c.891 0 1.616-.758 1.616-1.691 0-1.017-.441-1.375-1.1-1.609L7.1 13.417c-.658-.234-1.1-.592-1.1-1.609 0-.933.725-1.691 1.617-1.691h2.091c1.025 0 1.85.866 1.85 1.941M8.773 9v10M22.657 3.414l-4.243 4.243V4.828M18.414 7.657h2.829"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M15 4.594 12.5 5.78 9 4.594 6 5.78 2 4v19l3.417-1.781L9 23l3.5-1.781L16 23V11.5"
}));
export default PayInProviderIcon;